import createTheme from '@mui/material/styles/createTheme';

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#3D52A0' },
    secondary: { main: '#7091E6' },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#90caf9' },
    secondary: { main: '#f48fb1' },
  },
});
